import React from "react";

import "./styles.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";

import Frontpage from "./pages/Frontpage";
import About from "./pages/About";
import Products from "./pages/Products";
import Delivery from "./pages/Delivery";
import Contact from "./pages/Contact";
import CEOMessage from "./pages/CEOMessage";
export default function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route exact={true} path="/" element={<Frontpage />} />
        <Route exact={true} path="/products" element={<Products />} />
        <Route exact={true} path="/about" element={<About />} />
        <Route exact={true} path="/contact" element={<Contact />} />
        <Route exact={true} path="/delivery" element={<Delivery />} />
        <Route exact={true} path="/ceomessage" element={<CEOMessage />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}
